/**
 * Limits Easify "Free Toppings" checkboxes to a maximum of 3 on bowl product pages.
 */
(function () {
  const body = document.body;
  if (!body?.classList.contains('reves-bowl-product')) return;

  const MAX_TOPPINGS = Number(body.dataset.revesToppingsMax) || 3;
  const errorMessage =
    body.dataset.revesToppingsError || 'Please choose up to 3 free toppings.';
  const CHECKBOX_SELECTOR = '.tpo-checkbox-button[type="checkbox"]';
  const HIDDEN_SELECTOR = 'input.tpo_hidden-checkbox[name="properties[Free Toppings]"]';

  let styleInjected = false;

  function injectStyles() {
    if (styleInjected) return;
    styleInjected = true;
    const style = document.createElement('style');
    style.textContent = `
      .tpo_option-container.tpo-toppings-at-max .tpo-checkbox-button:not(:checked) + div {
        opacity: 0.45;
        pointer-events: none;
      }
      .reves-toppings-limit-notice {
        color: #c0392b;
        margin: 0.5rem 0 0;
        font-size: 0.875rem;
      }
    `;
    document.head.appendChild(style);
  }

  function getFreeToppingsGroup() {
    const hidden = document.querySelector(HIDDEN_SELECTOR);
    return hidden?.closest('.tpo_option-container') ?? null;
  }

  function getCheckedCount(group) {
    if (!group) return 0;
    return group.querySelectorAll(`${CHECKBOX_SELECTOR}:checked`).length;
  }

  function exceedsLimit() {
    const group = getFreeToppingsGroup();
    return getCheckedCount(group) > MAX_TOPPINGS;
  }

  function getErrorContainer(group) {
    if (!group) return null;
    return group.querySelector('.tpo_error-message');
  }

  function showError() {
    injectStyles();
    const group = getFreeToppingsGroup();
    const errorEl = getErrorContainer(group);
    if (errorEl) {
      errorEl.textContent = errorMessage;
      errorEl.setAttribute('role', 'alert');
      return;
    }

    if (document.querySelector('.reves-toppings-limit-notice')) return;

    const notice = document.createElement('p');
    notice.className = 'reves-toppings-limit-notice cart-primary-typography';
    notice.setAttribute('role', 'alert');
    notice.textContent = errorMessage;

    const anchor =
      group ||
      document.querySelector('.tpo_total-additional-price-wrapper') ||
      document.querySelector('[class*="tpo"]') ||
      document.querySelector('product-form-component');

    if (anchor?.parentElement) {
      anchor.parentElement.insertBefore(notice, anchor.nextSibling);
    }
  }

  function clearError() {
    const group = getFreeToppingsGroup();
    const errorEl = getErrorContainer(group);
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.removeAttribute('role');
    }
    document.querySelector('.reves-toppings-limit-notice')?.remove();
  }

  function blockElement(el) {
    if (!el || el.dataset.revesToppingsGuard === '1') return;
    el.dataset.revesToppingsGuard = '1';
    if ('disabled' in el) {
      el.disabled = true;
    }
    el.setAttribute('aria-disabled', 'true');
  }

  function unblockElement(el) {
    if (!el || el.dataset.revesToppingsGuard !== '1') return;
    delete el.dataset.revesToppingsGuard;
    if ('disabled' in el) {
      el.disabled = false;
    }
    el.removeAttribute('aria-disabled');
  }

  function updateAddToCartState() {
    const group = getFreeToppingsGroup();
    if (!group) return;

    const count = getCheckedCount(group);
    const atMax = count >= MAX_TOPPINGS;
    const overLimit = count > MAX_TOPPINGS;

    group.classList.toggle('tpo-toppings-at-max', atMax);

    const addSelectors = [
      'button[name="add"]',
      '.tpo-add-to-cart',
      '[data-tpo-add-to-cart]',
      '[class*="tpo"] button[type="submit"]',
    ];

    addSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (overLimit) {
          blockElement(el);
        } else {
          unblockElement(el);
        }
      });
    });
  }

  function handleCheckboxChange(event) {
    const checkbox = event.target;
    if (!(checkbox instanceof HTMLInputElement)) return;
    if (!checkbox.matches(CHECKBOX_SELECTOR)) return;

    const group = getFreeToppingsGroup();
    if (!group?.contains(checkbox)) return;

    if (checkbox.checked && getCheckedCount(group) > MAX_TOPPINGS) {
      checkbox.checked = false;
      showError();
    } else if (!exceedsLimit()) {
      clearError();
    }

    updateAddToCartState();
  }

  function handleCheckboxClick(event) {
    const checkbox = event.target;
    if (!(checkbox instanceof HTMLInputElement)) return;
    if (!checkbox.matches(CHECKBOX_SELECTOR)) return;

    const group = getFreeToppingsGroup();
    if (!group?.contains(checkbox)) return;

    if (!checkbox.checked && getCheckedCount(group) >= MAX_TOPPINGS) {
      event.preventDefault();
      showError();
    }
  }

  function guardSubmit(event) {
    if (!exceedsLimit()) return;

    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;

    event.preventDefault();
    event.stopPropagation();
    showError();
  }

  function guardAddClick(event) {
    if (!exceedsLimit()) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const addControl = target.closest(
      'button[name="add"], .tpo-add-to-cart, [data-tpo-add-to-cart], [class*="tpo"] button[type="submit"]'
    );
    if (!addControl) return;

    event.preventDefault();
    event.stopPropagation();
    showError();
  }

  function bindCheckboxListeners() {
    const group = getFreeToppingsGroup();
    if (!group) return;
    updateAddToCartState();
  }

  function init() {
    injectStyles();
    bindCheckboxListeners();
  }

  document.addEventListener('change', handleCheckboxChange, true);
  document.addEventListener('click', handleCheckboxClick, true);
  document.addEventListener('submit', guardSubmit, true);
  document.addEventListener('click', guardAddClick, true);

  init();
  const observer = new MutationObserver(() => init());
  observer.observe(document.body, { childList: true, subtree: true });
})();
